export const callApi = async (
  url: string,
  config: any,
  auth: boolean,
  gzip: boolean = false,
  key: string = '',
  method: string = 'GET'
) => {
  let body;
  let queryParams = '';
  if (config) {
    body = config.body;

    if (config.queryParams) {
      const paramsKeys = Object.keys(config.queryParams);

      queryParams = paramsKeys
        .map((key, index) => {
          const prefix = index === 0 ? '?' : '';

          return `${prefix}${key}=${config.queryParams[key]}`;
        })
        .join('&');
    }
  }
  let headers = {
    ...config,
    body: JSON.stringify(body),
  };

  if (auth) {
    headers = {
      ...config,
      headers: {
        authorization: `Bearer ${localStorage.getItem('auth-token')}`,
      },
      mode: 'cors',
      body: JSON.stringify(body),
    };
  }

  if (gzip) {
    headers = {
      ...headers,
      headers: {
        ...headers['headers'],
        //'accept-encoding': 'gzip'
      },
      gzip: true,
    };
  }

  if (key) {
    headers = {
      ...headers,
      headers: {
        ...headers['headers'],
        'x-api-key': key,
      },
    };
  }
  // console.log('headers ', headers)

  try {
    let response;
    if (method === 'POST') {
      response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(body),
      });
    } else {
      response = await fetch(`${url}${queryParams}`, headers);
    }
    /*
      fetch can either
      - return response
        - success: status_code 200
        - failed: status_code: 4xx, 5xx
      - throw an error
    */
    if (response.ok) {
      const json = await response.text();
      try {
        return JSON.parse(json);
      } catch (error) {
        return json;
      }
    }
    return `${response.status}: ${response.statusText || 'Error'}`;
  } catch (error) {
    const path = new URL(url).pathname;
    const parts = path.split('/');
    const apiName = parts[parts.length - 1];

    const trackBugsURL = 'https://iph0vhcscg.execute-api.us-east-2.amazonaws.com/default/trackBugs';
    const config = {
      queryParams: {
        bug: apiName,
      },
    };
    callApi(trackBugsURL, config, true);
    return error;
  }
};
